import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {NeutralButton} from "../../../../basic-components/buttons/neutral-button";
import {DotsAnimationComponent} from "../../../../components/dots-animation/dots-animation.component";
import styled from "styled-components";

const NeutralButtonBox = styled(NeutralButton)`
    min-width:  180px;
    min-height: 54px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: ${props => props.theme.fontSize.h4};
    gap: ${props => props.theme.spacing.spacing8};
    white-space: nowrap;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        min-width:  160px;
        min-height: 45px;
    }
`

interface PayBookingButtonWrapperComponentProps {
    renderPayButton: () => React.ReactElement | null;
}
export const PayBookingButtonWrapperComponent: React.FC <PayBookingButtonWrapperComponentProps> = observer((props) => {
    const services = useServices();

    if(!services.booking.currentPageCanBeRendered) {
        return null;
    }

    const booking = services.booking.current;

    if(booking.mutationsManager.isMutationInProgress) {
        return (
            <NeutralButtonBox disabled={true}>
                <DotsAnimationComponent/>
            </NeutralButtonBox>
        )
    }

    const payButton = props.renderPayButton();
    if(!payButton) {
        return null;
    }

    return payButton;
})